export var MessagesList = {
  2: { parts_length: 0 },
  59: ["string"],
  60: {
    parts_length: 1,
    data: [{ name: "settings", type: "string" }]
  },
  61: ["string", "string"],
  63: {
    parts_length: 12,
    data: [
      { name: "serverSeedSHA256", type: "string" },
      { name: "clientSeed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "balance", type: "number" },
      { name: "user_id", type: "string" },
      { name: "user_name", type: "base64" },
      {
        name: "game_settings",
        type: "objects",
        delimeter: "|",
        parts_length: 2,
        obj: [
          { name: "coefs", type: "table", delimeter: ";", subdelimeter: ":" },
          { name: "last_ball", type: "array", delimeter: ";" }
        ]
      },
      { name: "minBet", type: "number" },
      { name: "maxBet", type: "number" },
      { name: "currency", type: "string" },
      { name: "afterDot", type: "number" },
      { name: "next_server_seed_SHA256", type: "string" }
    ]
  },
  64: ["number", "string"],
  65: {
    parts_length: 8,
    data: [
      { name: "selectedNumbers", type: "array", delimeter: ";" },
      { name: "numbers", type: "array", delimeter: ";" },
      { name: "winNumbers", type: "array", delimeter: ";" },
      { name: "balance", type: "number" },
      { name: "winAmount", type: "number" },
      { name: "winMult", type: "number" },
      { name: "betAmount", type: "number" },
      { name: "betid", type: "number" }
    ]
  },

  67: {
    parts_length: 13,
    data: [
      { name: "round_id", type: "string" },
      { name: "user_name", type: "base64" },
      { name: "user_id", type: "string" },
      { name: "betAmount", type: "number" },
      { name: "winAmount", type: "number" },
      { name: "winCoef", type: "number" },
      { name: "currency", type: "string" },
      { name: "bigWin", type: "int" },
      { name: "bet_id", type: "int" },
      { name: "history", type: "int" },
      { name: "sessionNo", type: "string" },
      { name: "time", type: "string" },
      { name: "gameplaydata", type: "string" }
    ]
  },
  90: {
    parts_length: 1,
    data: [{ name: "errorCode", type: "int" }]
  },
  101: ["string"],
  116: ["string"],
  117: {
    parts_length: 17,
    data: [
      { name: "user_id", type: "string" },
      { name: "user_name", type: "base64" },
      { name: "bet_id", type: "int" },
      { name: "round_id", type: "string" },
      { name: "betAmount", type: "number" },
      { name: "winAmount", type: "number" },
      { name: "currency", type: "string" },
      { name: "winCoef", type: "number" },
      { name: "bigWin", type: "int" },
      { name: "server_seed", type: "string" },
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "date", type: "string" },
      { name: "selectedNumbers", type: "array", delimeter: ";" },
      { name: "numbers", type: "array", delimeter: ";" },
      { name: "winNumbers", type: "array", delimeter: ";" },
    ],
  },
  118: {},
  119: {
    parts_length: 8,
    data: [
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },

      { name: "old_server_seed", type: "string" },
      { name: "old_server_seed_SHA256", type: "string" },
      { name: "old_client_seed", type: "string" },
      { name: "old_nonce", type: "int" },
      // { name: "sessionNo", type: "string" },


      { name: "next_server_seed_SHA256", type: "string" }
    ]
  },
  120: {},
  121: {
    parts_length: 3,
    data: [
      { name: "all_stats", type: "array", delimeter: ";" },
      { name: "my_stats", type: "array", delimeter: ";" },
      { name: "big_stats", type: "array", delimeter: ";" }
    ]
  }
};

export var KenoType = {
  KENO_40_BALL: "40",
  KENO_80_BALL: "80"
};

// 67: {
//   parts_length: 10,
//   data: [
//     { name: "round_id", type: "string" },
//     { name: "user_name", type: "base64" },
//     { name: "user_id", type: "string" },
//     { name: "betAmount", type: "number" },
//     { name: "winAmount", type: "number" },
//     { name: "winCoef", type: "number" },
//     { name: "winMult", type: "number" },
//     { name: "currency", type: "int" },
//     { name: "bigWin", type: "int" },
//     { name: "bet_id", type: "int" },
//   ],
// },
